import { cloneDeep, each, filter, floor, groupBy, isEmpty, pick, reverse, sumBy } from 'lodash';
import { COMBOS } from '../constant';
import { CouponTypeEnum, DiscountTypeEnum, EatTypeEnum, OffTypeEnum, ProductRelationEnum, ProductTypeEnum, StatusEnum, UseLimitTypeEnum, UsePromoCodeStatusEnum, } from '../enum';
import { findActivityProduct, toFixed } from '../lib/utils';
/**
 * 指定餐品满减优惠
 * @param opt
 * @returns
 */
export default function calDesignatedItem(opt) {
    var _a, _b;
    const { designatedItems, productMap, designateCoupons, isSelectCoupon, eatType, couponsConfigMap, menuPoducts, usePromoCodeStatus, productAllOff, genSelectCouponIds, memberItemCouponMap, memberCouponMap, selectCouponIds, itemMap = {}, fullItemNFreeMap, todayUsedCntMap, } = opt;
    let { designatedItemDiscountActivitys, joinDesignateCoupons, enablePromoCodeActivity } = opt;
    const originFullItemNFreeMap = cloneDeep(fullItemNFreeMap);
    const joinDesignateCouponIds = [];
    if (isSelectCoupon) {
        const originDesignatedItemDiscountActivitys = cloneDeep(designatedItemDiscountActivitys);
        designatedItemDiscountActivitys = [];
        each(reverse(selectCouponIds), (selectCouponId) => {
            if (memberCouponMap[selectCouponId] && memberCouponMap[selectCouponId].type === CouponTypeEnum.Designate) {
                joinDesignateCouponIds.push(selectCouponId);
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                designatedItemDiscountActivitys.push(memberCouponMap[selectCouponId]);
            }
        });
        if (joinDesignateCouponIds.length <= 0) {
            if (originDesignatedItemDiscountActivitys.length > 0) {
                designatedItemDiscountActivitys = originDesignatedItemDiscountActivitys;
            }
            else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                designatedItemDiscountActivitys.push(...designateCoupons);
            }
        }
    }
    else if (!isSelectCoupon) {
        if (joinDesignateCoupons.length <= 0 && designateCoupons.length > 0) {
            joinDesignateCoupons = designateCoupons;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        designatedItemDiscountActivitys.push(...joinDesignateCoupons);
    }
    else {
        canUseDesignatedCoupon({ designateCoupons, designatedItems, couponsConfigMap });
    }
    each(designatedItemDiscountActivitys, (designatedItemDiscountActivity) => {
        if (designatedItemDiscountActivity.couponId) {
            designatedItemDiscountActivity.extra = couponsConfigMap[designatedItemDiscountActivity.couponId].extra;
            designatedItemDiscountActivity.productMap = couponsConfigMap[designatedItemDiscountActivity.couponId].productMap;
        }
    });
    // 生效的活动
    let oneReslult;
    const disableCouponIds = [];
    const notEnougthFeeCouponIds = [];
    let useGroupAvailableAverlayCouponRes;
    if (designatedItemDiscountActivitys.length > 0 && designatedItems.length > 0) {
        const availableAverlayCoupons = [];
        // 遍历活动,判断每个活动是否满足
        each(designatedItemDiscountActivitys, (activity) => {
            if (activity.couponId && (activity === null || activity === void 0 ? void 0 : activity.useLimitType) === UseLimitTypeEnum.EveryDay) {
                if (todayUsedCntMap.get(activity.couponId) >= (activity.useLimitCnt || 1)) {
                    return true;
                }
            }
            const res = calOneDesignated({
                activity,
                usePromoCodeStatus,
                eatType,
                designatedItems,
                itemMap: cloneDeep(itemMap),
                memberCouponMap: cloneDeep(memberCouponMap),
                productMap,
                genSelectCouponIds: cloneDeep(genSelectCouponIds),
                enablePromoCodeActivity: cloneDeep(enablePromoCodeActivity),
                productAllOff,
                memberItemCouponMap: cloneDeep(memberItemCouponMap),
                disableCouponIds,
                notEnougthFeeCouponIds,
                joinDesignateCouponIds,
                isSelectCoupon,
                fullItemNFreeMap,
                selectCouponIds: opt.selectCouponIds,
            });
            // 有优惠的优惠券,满减券,可以使用的数量
            if (res &&
                res.designatedItemAllOff > 0 &&
                activity.couponId &&
                activity.discountType === DiscountTypeEnum.DiscountFee &&
                (activity === null || activity === void 0 ? void 0 : activity.extra) &&
                activity.extra.quantityForSingleOrder &&
                activity.extra.noOverlyingSelf) {
                availableAverlayCoupons.push({
                    couponId: activity.couponId,
                    coupon: activity,
                    res,
                });
            }
            if (res && res.designatedItemAllOff > 0 && !oneReslult) {
                oneReslult = res;
            }
            if (oneReslult && (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.designatedItemAllOff) < ((res === null || res === void 0 ? void 0 : res.designatedItemAllOff) || 0)) {
                oneReslult = res;
            }
            if (activity.couponId && (activity === null || activity === void 0 ? void 0 : activity.useLimitType) === UseLimitTypeEnum.EveryDay) {
                if (todayUsedCntMap.get(activity.couponId) < (activity.useLimitCnt || 1)) {
                    todayUsedCntMap.increase(activity.couponId);
                }
            }
        });
        // 可以使用的
        if (availableAverlayCoupons.length > 0) {
            each(groupBy(availableAverlayCoupons, 'couponId'), (groupAvailableAverlayCoupons) => {
                var _a, _b, _c, _d, _e, _f;
                let complex = floor(groupAvailableAverlayCoupons[0].res.effectJoinAllPrice / groupAvailableAverlayCoupons[0].coupon.discountValue);
                if (((_b = (_a = groupAvailableAverlayCoupons[0].coupon) === null || _a === void 0 ? void 0 : _a.extra) === null || _b === void 0 ? void 0 : _b.quantityForSingleOrder) &&
                    complex > ((_d = (_c = groupAvailableAverlayCoupons[0].coupon) === null || _c === void 0 ? void 0 : _c.extra) === null || _d === void 0 ? void 0 : _d.quantityForSingleOrder)) {
                    complex = (_f = (_e = groupAvailableAverlayCoupons[0].coupon) === null || _e === void 0 ? void 0 : _e.extra) === null || _f === void 0 ? void 0 : _f.quantityForSingleOrder;
                }
                if (complex) {
                    const maxOffFee = groupAvailableAverlayCoupons[0].coupon.discountValue * complex;
                    if (oneReslult && maxOffFee > (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.designatedItemAllOff)) {
                        const tempGroupAvailableAverlayCoupons = [];
                        const moreReslult = [];
                        for (let i = 0; i < complex; i++) {
                            if (groupAvailableAverlayCoupons[i]) {
                                tempGroupAvailableAverlayCoupons.push(groupAvailableAverlayCoupons[i].coupon);
                                moreReslult.push(groupAvailableAverlayCoupons[i].res);
                            }
                        }
                        if (!useGroupAvailableAverlayCouponRes || useGroupAvailableAverlayCouponRes.maxOffFee < maxOffFee) {
                            useGroupAvailableAverlayCouponRes = {
                                coupons: tempGroupAvailableAverlayCoupons,
                                couponId: groupAvailableAverlayCoupons[0].coupon.couponId,
                                maxOffFee,
                                moreReslult,
                            };
                        }
                    }
                }
            });
        }
    }
    else {
        if (designateCoupons.length > 0) {
            each(designateCoupons, (designateCoupon) => {
                const memberCouponId = designateCoupon.memberCouponId;
                memberCouponMap[memberCouponId].canUse = false;
                memberCouponMap[memberCouponId].isSelect = false;
                memberCouponMap[memberCouponId].status = StatusEnum.Disable;
            });
        }
    }
    let result = {
        offArr: [],
        productAllOff: 0,
        designatedItemAllOff: 0,
        usePromoCodeStatus: usePromoCodeStatus,
        disableCouponIds: [],
    };
    let effectActivity;
    let effectJoinAllPrice = 0;
    let effectComplex = 0; // 生效的循环
    let designatedItemAllOff = 0;
    if (oneReslult && !useGroupAvailableAverlayCouponRes) {
        if (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.itemMap) {
            each(oneReslult.itemMap, (item, key) => {
                itemMap[key] = item;
            });
        }
        effectActivity = oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.effectActivity;
        effectJoinAllPrice = oneReslult.effectJoinAllPrice;
        effectComplex = oneReslult.effectComplex; // 生效的循环
        if (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.genSelectCouponIds) {
            for (const id of oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.genSelectCouponIds) {
                genSelectCouponIds.add(id);
            }
        }
        if (effectActivity && effectActivity.memberCouponId) {
            memberCouponMap[effectActivity.memberCouponId] = oneReslult.memberCouponMap[effectActivity.memberCouponId];
        }
        if (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.memberItemCouponMap) {
            each(oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.memberItemCouponMap, (memberItemCoupon) => {
                memberItemCouponMap[memberItemCoupon.memberCouponId] = memberItemCoupon;
            });
        }
        enablePromoCodeActivity = (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.enablePromoCodeActivity) || enablePromoCodeActivity;
        designatedItemAllOff = oneReslult.designatedItemAllOff || 0;
        result = {
            offArr: (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.offArr) || [],
            productAllOff: oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.productAllOff,
            designatedItemAllOff,
            usePromoCodeStatus: (oneReslult === null || oneReslult === void 0 ? void 0 : oneReslult.usePromoCodeStatus) || usePromoCodeStatus,
            disableCouponIds,
            enablePromoCodeActivity: oneReslult.enablePromoCodeActivity,
        };
    }
    else {
        const moreOffArr = [];
        let moreProductAllOff = 0;
        each(useGroupAvailableAverlayCouponRes === null || useGroupAvailableAverlayCouponRes === void 0 ? void 0 : useGroupAvailableAverlayCouponRes.moreReslult, (result) => {
            moreOffArr.push(...result.offArr);
            moreProductAllOff += result.productAllOff;
            designatedItemAllOff += result.designatedItemAllOff;
            if (result === null || result === void 0 ? void 0 : result.itemMap) {
                each(result.itemMap, (item, key) => {
                    itemMap[key] = item;
                });
            }
            if (result === null || result === void 0 ? void 0 : result.genSelectCouponIds) {
                for (const id of result === null || result === void 0 ? void 0 : result.genSelectCouponIds) {
                    genSelectCouponIds.add(id);
                }
            }
            if (result.effectActivity && result.effectActivity.memberCouponId) {
                memberCouponMap[result.effectActivity.memberCouponId] =
                    result.memberCouponMap[result.effectActivity.memberCouponId];
            }
            if (result === null || result === void 0 ? void 0 : result.memberItemCouponMap) {
                each(result === null || result === void 0 ? void 0 : result.memberItemCouponMap, (memberItemCoupon) => {
                    memberItemCouponMap[memberItemCoupon.memberCouponId] = memberItemCoupon;
                });
            }
        });
        result = {
            offArr: moreOffArr,
            productAllOff: moreProductAllOff,
            designatedItemAllOff,
            usePromoCodeStatus: usePromoCodeStatus,
            disableCouponIds,
            enablePromoCodeActivity: null,
        };
    }
    if (notEnougthFeeCouponIds.length > 0) {
        each(notEnougthFeeCouponIds, (memberCouponId) => {
            memberCouponMap[memberCouponId].canUse = false;
            memberCouponMap[memberCouponId].isSelect = false;
            memberCouponMap[memberCouponId].status = StatusEnum.Disable;
        });
    }
    let buyAgainFee = 0;
    // 满减活动
    if (effectActivity &&
        // !effectActivity.couponId &&
        !((_a = effectActivity === null || effectActivity === void 0 ? void 0 : effectActivity.extra) === null || _a === void 0 ? void 0 : _a.closeDesignatedBuyAgain)) {
        buyAgainFee = effectActivity.orderFee * (effectComplex + 1) - effectJoinAllPrice;
        const activityProducts = [];
        const isAllProduct = effectActivity.productRelation === ProductRelationEnum.All;
        const isAllCombo = effectActivity.productComboRelation === ProductRelationEnum.All;
        if (!isAllProduct || !isAllCombo) {
            each(menuPoducts, (menuPoduct) => {
                let canJoinActivity = false;
                if ((effectActivity.productRelation === ProductRelationEnum.All &&
                    (menuPoduct.type === ProductTypeEnum.Product || menuPoduct.type === ProductTypeEnum.MallProduct)) ||
                    (effectActivity.productComboRelation === ProductRelationEnum.All && COMBOS.includes(menuPoduct.type))) {
                    canJoinActivity = true;
                }
                else {
                    const findProduct = findActivityProduct(effectActivity.productMap, menuPoduct);
                    if (findProduct &&
                        (((menuPoduct.type === ProductTypeEnum.Product || menuPoduct.type === ProductTypeEnum.MallProduct) &&
                            effectActivity.productRelation === ProductRelationEnum.Included) ||
                            (COMBOS.includes(menuPoduct.type) &&
                                effectActivity.productComboRelation === ProductRelationEnum.Included))) {
                        canJoinActivity = true;
                    }
                    else if (!findProduct &&
                        (((menuPoduct.type === ProductTypeEnum.Product || menuPoduct.type === ProductTypeEnum.MallProduct) &&
                            effectActivity.productRelation === ProductRelationEnum.Excluded) ||
                            (COMBOS.includes(menuPoduct.type) &&
                                effectActivity.productComboRelation === ProductRelationEnum.Excluded))) {
                        canJoinActivity = true;
                    }
                }
                if (canJoinActivity && menuPoduct) {
                    activityProducts.push(pick(menuPoduct, ['categoryNo', 'productNo', 'scaleNo', 'type']));
                }
            });
        }
        let maxDiscountFee = effectActivity.maxDiscountFee || 0;
        if ((_b = effectActivity === null || effectActivity === void 0 ? void 0 : effectActivity.extra) === null || _b === void 0 ? void 0 : _b.noOverlyingSelf) {
            maxDiscountFee = effectActivity.discountValue;
        }
        let futureAllDiscountFee = buyAgainFee > 0 ? effectActivity.discountValue + designatedItemAllOff : 0;
        if (maxDiscountFee && designatedItemAllOff >= maxDiscountFee) {
            futureAllDiscountFee = 0;
            buyAgainFee = 0;
        }
        if (maxDiscountFee && futureAllDiscountFee > maxDiscountFee) {
            futureAllDiscountFee = maxDiscountFee;
        }
        result.designatedBuyAgain = {
            // 指定满减,再买多少减多少
            buyAgainFee: buyAgainFee > 0 ? buyAgainFee : 0,
            nextDiscountFee: futureAllDiscountFee > 0 ? toFixed(futureAllDiscountFee - designatedItemAllOff) : 0,
            futureAllDiscountFee,
            activityProducts: isAllProduct && isAllCombo ? [] : activityProducts,
            nowOff: designatedItemAllOff,
            activityName: effectActivity.activityName || effectActivity.couponName,
            maxDiscountFee: maxDiscountFee,
            isAllProduct: isAllProduct,
            isAllCombo: isAllCombo,
            activityId: effectActivity.activityId || effectActivity.couponId,
        };
    }
    if ((result === null || result === void 0 ? void 0 : result.designatedItemAllOff) <= 0) {
        each(originFullItemNFreeMap, (v, k) => {
            fullItemNFreeMap[k] = v;
        });
    }
    return result;
}
/**
 * 计算优惠券能不能使用
 * @param opt
 */
function canUseDesignatedCoupon(opt) {
    const { designateCoupons, designatedItems, couponsConfigMap } = opt;
    each(designateCoupons, (designateCoupon) => {
        const canJoinProducts = [];
        each(designatedItems, (product) => {
            if ((designateCoupon.productRelation === ProductRelationEnum.All &&
                (product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct)) ||
                (designateCoupon.productComboRelation === ProductRelationEnum.All && COMBOS.includes(product.type))) {
                canJoinProducts.push(product);
            }
            else {
                const findProduct = findActivityProduct(couponsConfigMap[designateCoupon.couponId].productMap || designateCoupon.productMap, product);
                if (findProduct &&
                    (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                        designateCoupon.productRelation === ProductRelationEnum.Included) ||
                        (COMBOS.includes(product.type) && designateCoupon.productComboRelation === ProductRelationEnum.Included))) {
                    canJoinProducts.push(product);
                }
                else if (!findProduct &&
                    (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                        designateCoupon.productRelation === ProductRelationEnum.Excluded) ||
                        (COMBOS.includes(product.type) && designateCoupon.productComboRelation === ProductRelationEnum.Excluded))) {
                    canJoinProducts.push(product);
                }
            }
        });
        if (canJoinProducts.length <= 0) {
            designateCoupon.canUse = false;
        }
        else {
            designateCoupon.memberCardOff = sumBy(canJoinProducts, (product) => {
                if (product.offType === OffTypeEnum.MemberCard) {
                    return product.off;
                }
                return 0;
            });
        }
    });
}
/**
 * 一个计算
 * @param opt
 * @returns
 */
function calOneDesignated(opt) {
    var _a, _b, _c, _d, _e, _f, _g;
    let designatedItemAllOff = 0;
    // 生效的活动
    let effectActivity;
    let effectJoinAllPrice = 0;
    let effectComplex = 0; // 生效的循环
    const removeMemberCouponMap = {};
    let { usePromoCodeStatus, productAllOff } = opt;
    const { activity, eatType, designatedItems, itemMap, memberItemCouponMap, productMap, memberCouponMap, genSelectCouponIds, enablePromoCodeActivity, disableCouponIds, notEnougthFeeCouponIds, joinDesignateCouponIds, isSelectCoupon, fullItemNFreeMap, } = opt;
    if (activity.couponId) {
        if (!activity.canUse) {
            return null;
        }
    }
    if (activity.discountType === DiscountTypeEnum.DiscountRate && activity.discountValue === 1) {
        return null;
    }
    if (activity.promoCode && usePromoCodeStatus === UsePromoCodeStatusEnum.Unused) {
        usePromoCodeStatus = UsePromoCodeStatusEnum.Ineffective;
    }
    // 能参加的活动餐品
    let canJoinProducts = [];
    if ((activity.productRelation === ProductRelationEnum.All &&
        activity.productComboRelation === ProductRelationEnum.All &&
        eatType !== EatTypeEnum.Mall) ||
        (activity.productRelation === ProductRelationEnum.All && eatType === EatTypeEnum.Mall)) {
        canJoinProducts = designatedItems;
    }
    else {
        each(designatedItems, (product) => {
            if ((activity.productRelation === ProductRelationEnum.All &&
                (product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct)) ||
                (activity.productComboRelation === ProductRelationEnum.All && COMBOS.includes(product.type))) {
                canJoinProducts.push(product);
            }
            else {
                const findProduct = findActivityProduct(activity.productMap, product);
                if (findProduct &&
                    (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                        activity.productRelation === ProductRelationEnum.Included) ||
                        (COMBOS.includes(product.type) && activity.productComboRelation === ProductRelationEnum.Included))) {
                    canJoinProducts.push(product);
                }
                else if (!findProduct &&
                    (((product.type === ProductTypeEnum.Product || product.type === ProductTypeEnum.MallProduct) &&
                        activity.productRelation === ProductRelationEnum.Excluded) ||
                        (COMBOS.includes(product.type) && activity.productComboRelation === ProductRelationEnum.Excluded))) {
                    canJoinProducts.push(product);
                }
            }
        });
    }
    const offArr = [];
    let joinAllPrice = 0;
    // 能参加的餐品必须有才行
    if (canJoinProducts.length > 0) {
        const activityJoinPks = new Set([]);
        if ((_a = activity.extra) === null || _a === void 0 ? void 0 : _a.isOverlySingleItemDiscount) {
            // 能叠加
            each(canJoinProducts, (product) => {
                const pk = product.pk || product.productNo + '_' + product.scaleNo;
                const item = itemMap[pk];
                joinAllPrice += product.productAndModifierPrice * (product.cnt || 1) - ((item === null || item === void 0 ? void 0 : item.itemAllOff) || 0);
                activityJoinPks.add(pk);
            });
        }
        else {
            // 不能叠加
            if (
            // 本活动优先
            ((_b = activity.extra) === null || _b === void 0 ? void 0 : _b.discountWithSingleItemFirst) === 'activity' ||
                // 或者手动选择了这个优惠券
                (isSelectCoupon && joinDesignateCouponIds.includes(activity === null || activity === void 0 ? void 0 : activity.memberCouponId))) {
                // 本活动优先
                each(canJoinProducts, (product) => {
                    const pk = product.pk || product.productNo + '_' + product.scaleNo;
                    // 餐品需要没有参加指定活动
                    if (fullItemNFreeMap[pk]) {
                        if (activity.memberCouponId) {
                            if (opt.selectCouponIds.includes(activity.memberCouponId)) {
                                delete fullItemNFreeMap[pk];
                            }
                        }
                        else {
                            delete fullItemNFreeMap[pk];
                        }
                    }
                    const joinCnt = product.cnt || 1;
                    joinAllPrice += product.productAndModifierPrice * joinCnt;
                    activityJoinPks.add(pk);
                    const item = itemMap[pk];
                    (item === null || item === void 0 ? void 0 : item.items) &&
                        each(item.items, (ie) => {
                            if (ie.offType === OffTypeEnum.Coupon && memberItemCouponMap[ie.offId || 0]) {
                                if (!removeMemberCouponMap[pk]) {
                                    removeMemberCouponMap[pk] = [];
                                }
                                removeMemberCouponMap[pk].push(ie.offId || 0);
                            }
                        });
                });
            }
            else {
                // 其他单品折扣优先
                each(canJoinProducts, (product) => {
                    const pk = product.pk || product.productNo + '_' + product.scaleNo;
                    // 餐品需要没有参加指定活动
                    const item = itemMap[pk];
                    const joinOtherCnt = sumBy(item === null || item === void 0 ? void 0 : item.items, 'cnt') || 0;
                    const productCnt = product.cnt || 1;
                    if (joinOtherCnt < productCnt) {
                        joinAllPrice += product.productAndModifierPrice * (productCnt - joinOtherCnt);
                        activityJoinPks.add(pk);
                    }
                });
            }
        }
        if (joinAllPrice >= activity.orderFee) {
            effectActivity = activity;
            effectJoinAllPrice = joinAllPrice;
            if (!((_c = activity.extra) === null || _c === void 0 ? void 0 : _c.isOverlySingleItemDiscount)) {
                if (!isEmpty(removeMemberCouponMap) &&
                    (((_d = activity.extra) === null || _d === void 0 ? void 0 : _d.discountWithSingleItemFirst) === 'activity' ||
                        (isSelectCoupon && joinDesignateCouponIds.includes(activity === null || activity === void 0 ? void 0 : activity.memberCouponId)))) {
                    each(removeMemberCouponMap, (memberCouponIds, pk) => {
                        each(memberCouponIds, (memberCouponId) => {
                            if (memberCouponId) {
                                if (memberItemCouponMap[memberCouponId]) {
                                    memberItemCouponMap[memberCouponId].isSelect = false;
                                    memberItemCouponMap[memberCouponId].canUse = false;
                                    memberItemCouponMap[memberCouponId].canUseProductPk = [];
                                    memberItemCouponMap[memberCouponId].status = StatusEnum.Disable;
                                    memberItemCouponMap[memberCouponId].useItem = null;
                                }
                                // else if (memberCouponMap[memberCouponId]) {
                                //   disableCouponIds.push(memberCouponMap[memberCouponId].couponId)
                                //   memberCouponMap[memberCouponId].isSelect = false;
                                //   memberCouponMap[memberCouponId].status = StatusEnum.Disable;
                                // }
                            }
                        });
                        itemMap[pk].itemAllOff = 0;
                        itemMap[pk].items = [];
                        // const item = itemMap[pk];
                        // item.itemAllOff = 0;
                        // item.items = [];
                    });
                }
                else {
                    if (((_e = activity.extra) === null || _e === void 0 ? void 0 : _e.discountWithSingleItemFirst) === 'singleItemDiscount' &&
                        !isEmpty(fullItemNFreeMap) &&
                        !((_f = activity.extra) === null || _f === void 0 ? void 0 : _f.isOverlySingleItemDiscount)) {
                        if (activity.memberCouponId) {
                            genSelectCouponIds.delete(activity.memberCouponId);
                            memberCouponMap[activity.memberCouponId].canUse = false;
                            memberCouponMap[activity.memberCouponId].isSelect = false;
                            memberCouponMap[activity.memberCouponId].status = StatusEnum.Disable;
                            activity.canUse = false;
                            activity.isSelect = false;
                            activity.status = StatusEnum.Disable;
                        }
                    }
                }
                each(canJoinProducts, (product) => {
                    const pk = product.pk || product.productNo + '_' + product.scaleNo;
                    // 餐品需要没有参加指定活动
                    const item = itemMap[pk];
                    let joinCnt = product.cnt || 1;
                    if (item) {
                        const removePkIndexs = [];
                        each(item.items, (itemV, idx) => {
                            if (itemV.offType !== OffTypeEnum.Coupon &&
                                itemV.offType !== OffTypeEnum.Plan &&
                                !itemV.isFullItemNFree) {
                                removePkIndexs.push(idx);
                            }
                            else {
                                joinCnt = joinCnt - (itemV.cnt || 1);
                            }
                        });
                        productAllOff -= itemMap[pk].itemAllOff;
                        const stayItmes = [];
                        each(item.items, (item, index) => {
                            if (!removePkIndexs.includes(index)) {
                                stayItmes.push(item);
                            }
                        });
                        itemMap[pk].items = stayItmes;
                        itemMap[pk].itemAllOff = sumBy(itemMap[pk].items, 'off');
                        productAllOff += itemMap[pk].itemAllOff;
                        // if (activity.memberCouponId && memberCouponMap[activity.memberCouponId]) {
                        //   memberCouponMap[activity.memberCouponId].isSelect = true;
                        //   memberCouponMap[activity.memberCouponId].canUse = true;
                        //   memberCouponMap[activity.memberCouponId].status = StatusEnum.Enable;
                        // }
                    }
                });
            }
            const products = [];
            activityJoinPks.forEach((pk) => {
                var _a, _b, _c, _d;
                if ((_a = itemMap[pk]) === null || _a === void 0 ? void 0 : _a.items) {
                    products.push(...filter(itemMap[pk].items, (item) => {
                        var _a;
                        return item.offType !== OffTypeEnum.LadderDiscount &&
                            (item === null || item === void 0 ? void 0 : item.couponType) !== CouponTypeEnum.Ladder &&
                            item.productAndModifierPrice * ((_a = item.cnt) !== null && _a !== void 0 ? _a : 1) - item.off > 0;
                    }));
                    const itemCnt = sumBy(itemMap[pk].items, 'cnt');
                    const productCnt = ((_b = productMap[pk]) === null || _b === void 0 ? void 0 : _b.cnt) || 1;
                    if (itemCnt < productCnt) {
                        products.push(Object.assign(Object.assign({}, productMap[pk]), { cnt: productCnt - itemCnt, offType: OffTypeEnum.DesignatedItem }));
                        if (((_c = activity.extra) === null || _c === void 0 ? void 0 : _c.discountWithSingleItemFirst) === 'activity' &&
                            fullItemNFreeMap[pk] &&
                            !activity.extra.isOverlySingleItemDiscount) {
                            delete fullItemNFreeMap[pk];
                        }
                    }
                }
                else {
                    products.push(Object.assign({}, productMap[pk]));
                    if (((_d = activity.extra) === null || _d === void 0 ? void 0 : _d.discountWithSingleItemFirst) === 'activity' &&
                        fullItemNFreeMap[pk] &&
                        !activity.extra.isOverlySingleItemDiscount) {
                        delete fullItemNFreeMap[pk];
                    }
                }
            });
            let activityOff = 0;
            if (activity.discountType === DiscountTypeEnum.DiscountFee) {
                const noOverlyingSelf = (_g = activity.extra) === null || _g === void 0 ? void 0 : _g.noOverlyingSelf;
                let complex = floor(joinAllPrice / activity.orderFee, 0);
                if (noOverlyingSelf) {
                    // 可以循环的时候
                    complex = 1;
                }
                effectComplex = complex;
                activityOff = activity.discountValue * complex;
            }
            else {
                activityOff = toFixed(joinAllPrice * (1 - activity.discountValue));
            }
            if (activityOff > joinAllPrice) {
                activityOff = joinAllPrice;
            }
            if (activity.maxDiscountFee && activityOff > activity.maxDiscountFee) {
                activityOff = activity.maxDiscountFee;
            }
            designatedItemAllOff += activityOff;
            let offTip = '';
            let offId = 0;
            let offType = '';
            if (activity.activityId) {
                offTip = activity.activityName;
                offId = activity.activityId;
                offType = activity.promoCode ? OffTypeEnum.PromoCode : OffTypeEnum.Activity;
            }
            else if (activity.couponId && activity.canUse) {
                //指定满减优惠券
                offTip = activity.couponName;
                offId = activity.memberCouponId;
                offType = OffTypeEnum.Coupon;
                memberCouponMap[offId].isSelect = true;
                memberCouponMap[offId].status = StatusEnum.Enable;
                genSelectCouponIds.add(offId);
            }
            offArr.push({
                off: activityOff,
                offTip,
                offId,
                offType,
                orderPrice: joinAllPrice,
                products: products,
            });
            if (activityOff > 0 && activity.discountType === DiscountTypeEnum.DiscountFee) {
                effectActivity = activity;
                effectJoinAllPrice = joinAllPrice;
            }
            if (activity.promoCode) {
                if (usePromoCodeStatus === UsePromoCodeStatusEnum.Ineffective) {
                    usePromoCodeStatus = UsePromoCodeStatusEnum.Effective;
                }
                enablePromoCodeActivity.push(activity.activityId);
            }
        }
        else {
            if (activity.couponId) {
                //指定满减优惠
                disableCouponIds.push(activity.couponId);
                notEnougthFeeCouponIds.push(activity.memberCouponId);
            }
        }
    }
    else {
        if (activity.couponId) {
            //指定满减优惠
            disableCouponIds.push(activity.couponId);
            notEnougthFeeCouponIds.push(activity.memberCouponId);
        }
    }
    if (isSelectCoupon && joinDesignateCouponIds.length <= 0) {
        if (activity.memberCouponId) {
            designatedItemAllOff = 0;
            if (memberCouponMap[activity.memberCouponId].status === StatusEnum.Enable) {
                if (joinAllPrice < activity.orderFee) {
                    notEnougthFeeCouponIds.push(activity.memberCouponId);
                }
                else {
                    memberCouponMap[activity.memberCouponId].status = StatusEnum.Mutex;
                }
                memberCouponMap[activity.memberCouponId].isSelect = false;
                genSelectCouponIds.delete(activity.memberCouponId);
            }
            if (memberCouponMap[activity.memberCouponId].status === StatusEnum.Mutex) {
                if (joinAllPrice < activity.orderFee) {
                    notEnougthFeeCouponIds.push(activity.memberCouponId);
                }
            }
        }
    }
    if (joinDesignateCouponIds.length > 0 && !joinDesignateCouponIds.includes(activity.memberCouponId)) {
        designatedItemAllOff = 0;
    }
    return {
        offArr,
        productAllOff,
        designatedItemAllOff,
        effectActivity,
        effectJoinAllPrice,
        effectComplex,
        itemMap,
        memberCouponMap,
        memberItemCouponMap,
        genSelectCouponIds,
        enablePromoCodeActivity,
        usePromoCodeStatus,
    };
}
//# sourceMappingURL=calDesignatedItem.js.map